<div class="dialog-container" [ngClass]="isDesktop ? 'desktop': 'mobile'">
    <!-- <div class="content">
        <div class="payment-header" i18n>select deposit method</div>
    </div> -->
    <div class="title">{{selectDepositName}}:</div>
    <div class="payment-list">
        <div [ngClass]="item.id === selectedMethod?.id ? 'active' : 'default'" class="payment" *ngFor="let item of paymentList; let last = last;" (click)="selectPayment(item)">
            <div fxLayoutAlign="center" fxLayout="column">
                <div fxLayoutAlign="space-between center" fxLayoutGap="1px" fxLayout="row">
                    <div fxLayoutAlign="start center" fxLayout="column">
                        <div class="image"><img [src]="item.thumbnail?.url" /></div>

                    </div>
                    <div class="payment-info" fxLayoutAlign="start end" fxLayoutGap="4px" fxLayout="column">
                        <div class="name">{{item.name}}</div>
                        <div class="description-free">
                            <div i18n>free</div>
                        </div>
                    </div>
                </div>
                <div class="info">
                    <ng-container *ngIf="includedIds?.length > 0 else excludedIdContext">
                        <div fxLayout="row" fxLayoutGap="6px" fxLayoutAlign="start center" *ngIf="!includedIds?.includes(item.id)">
                            <img src="{{licenceService.getKey('icon-payment-not-available')}}" alt="icon-not-available-payment">
                            <div class="description not-available" i18n>This method is not avaialbe for selected bonus.</div>
                        </div>
                    </ng-container>
                    <ng-template #excludedIdContext>
                        <ng-container *ngTemplateOutlet="excludedIdCase; context: {$implicit: item}"></ng-container>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #excludedIdCase let-item>
    <div fxLayout="row" fxLayoutGap="6px" fxLayoutAlign="start center" *ngIf="excludedIds?.includes(item.id)">
        <img src="{{licenceService.getKey('icon-payment-not-available')}}" alt="icon-not-available-payment">
        <div class="description not-available" i18n>This method is not avaialbe for selected bonus.</div>
    </div>
</ng-template>
